export default {
  name: 'custom_date_field',
  component_path: 'modules/procedures/blocks/BlockInputDate',
  static_options: {
    format: 'yyyy/MM/dd HH:mm:ss',
    open_date: new Date()
  }
}